/**
 * Which kind of break a timetable row is, read from the institute's own name
 * for it — "Lunch break", "Morning assembly", "Short break".
 *
 * Every grid draws a break as one band across the week; this decides the icon
 * on that band and which figure the summary counts it under. One rule in one
 * place, so the office's grid, the class view, the teacher's grid and the
 * summary cards can never disagree about what a row is.
 */
export type BreakKind = 'LUNCH' | 'ASSEMBLY' | 'SHORT';

export function breakKindOf(label: string | null | undefined): BreakKind {
  const name = (label ?? '').toLowerCase();
  if (name.includes('lunch')) return 'LUNCH';
  if (name.includes('assembly')) return 'ASSEMBLY';
  return 'SHORT';
}
